import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {

  transform(phoneValue: string): any {
    try {
      const cleaned = ('' + phoneValue).replace(/\D/g, '');
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (!match) {
        return phoneValue;
      }
      return '' + match[1] + '-' + match[2] + '-' + match[3];
    } catch (error) {
      return phoneValue;
    }
  }
}
